module.exports = "../../static/fonts/Gotham-Bold.46e967b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Gotham-Bold.ttf
// module id = k5En
// module chunks = 47